import { createContext } from 'react';
/**
 * @typedef {Object} GlobalContextType
 * @property {Object} currentUser - Current logged-in user
 * @property {Object|null} currentCustomer - Currently selected customer
 * @property {Function} setCurrentCustomer - Updates currentCustomer state
 * @property {string|boolean} openDrawer - Drawer state (false or drawer type string: 'editMesaure', 'healthCoachSummery')
 * @property {Function} setOpenDrawer - Updates openDrawer state
 * @property {Array} measuresData - Array of measurement data
 * @property {Function} setMeasuresData - Updates measuresData state
 * @property {Function} setCurrentMeeting - Updates currentMeeting state
 * @property {Object} currentMeeting - Current meeting details
 * @property {Array} menuData - Navigation menu structure with role-based rules
 * @property {string|null} link - Current navigation link
 * @property {Function} setLink - Updates link state
 * @property {string|number|null} clientProductStageId - Current client product stage ID
 * @property {Function} setClientProductStageId - Updates clientProductStageId state
 * @property {Object|null} currentMeetingDetails - Details of the current meeting
 * @property {Function} setCurrentMeetingsDetails - Updates currentMeetingDetails state
 * @property {string|null} city - Selected city
 * @property {Function} setCity - Updates city state
 * @property {Array} categoriesList - List of all categories
 * @property {Object} currentProduct - Currently selected product
 * @property {Function} setCurrentProduct - Updates currentProduct state
 * @property {Array} organizationsList - List of all organizations
 * @property {Array} productsList - List of all products
 * @property {Object|null} steppersData - Stepper state data
 * @property {Function} setSteppersData - Updates steppersData state
 * @property {Array} regionEnum - Region enumeration: כללי, צפון, מרכז, דרום
 * @property {Array} typeEnum - Type enumeration: ידני, הרשמה
 * @property {Array} sourceList - Source enumeration: אורגני, פרסום, פייסבוק, טוויטר, אינסטגרם
 * @property {Array} globalProductInfo - Global product information
 * @property {Function} setGlobalProductInfo - Updates globalProductInfo state
 *
 *
 */
/** @type {React.Context<GlobalContextType>} */
const GlobalContext = createContext();

export default GlobalContext;
